import React, { lazy } from 'react';
import { Check, X } from 'lucide-react';
export function ComparisonSection() {
  const rows = [{
    feature: 'Duration',
    dentafix: 'Lasts up to 3 days',
    other: 'Fails within hours'
  }, {
    feature: 'Comfort',
    dentafix: 'Smooth gel comfort',
    other: 'Sticky, uncomfortable'
  }, {
    feature: 'Mess',
    dentafix: 'Clean, precise application',
    other: 'Messy paste everywhere'
  }, {
    feature: 'Grip',
    dentafix: 'Reliable all-day grip',
    other: 'Slips during meals'
  }, {
    feature: 'Application',
    dentafix: 'Simple gel application',
    other: 'Squeeze, spread, hope'
  }, {
    feature: 'Confidence',
    dentafix: 'Total confidence',
    other: 'Constant anxiety'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-101">
      <div className="container mx-auto px-4 md:px-6" data-id="element-102">
        <div className="text-center mb-12" data-id="element-103">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 font-serif" data-id="element-104">
            See the Difference for Yourself
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-12 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-105">
          <div className="relative rounded-2xl overflow-hidden shadow-lg border-2 border-green-200" data-id="element-106">
            <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80" alt="Clean, modern dental care" className="w-full h-56 object-cover" loading="lazy" data-id="element-107" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-900/80 to-transparent p-6" data-id="element-108">
              <div className="flex items-center gap-2" data-id="element-109">
                <div className="bg-green-500 p-1 rounded-full" data-id="element-110">
                  <Check className="w-4 h-4 text-white" data-id="element-111" />
                </div>
                <span className="text-white font-bold text-lg" data-id="element-112">
                  Dentafix™ Gel
                </span>
              </div>
              <p className="text-white/90 text-sm mt-1" data-id="element-113">
                Clean, precise, long-lasting
              </p>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-lg border-2 border-red-200 opacity-75" data-id="element-114">
            <img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&q=80" alt="Traditional messy adhesives" className="w-full h-56 object-cover grayscale" loading="lazy" data-id="element-115" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-red-900/80 to-transparent p-6" data-id="element-116">
              <div className="flex items-center gap-2" data-id="element-117">
                <div className="bg-red-500 p-1 rounded-full" data-id="element-118">
                  <X className="w-4 h-4 text-white" data-id="element-119" />
                </div>
                <span className="text-white font-bold text-lg" data-id="element-120">
                  Traditional Adhesives
                </span>
              </div>
              <p className="text-white/90 text-sm mt-1" data-id="element-121">
                Messy, unreliable, uncomfortable
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200" data-id="element-122">
          <div className="grid grid-cols-3 bg-gray-50 border-b border-gray-200" data-id="element-123">
            <div className="p-4 md:p-6 font-bold text-gray-500 text-sm md:text-lg" data-id="element-124">
              Feature
            </div>
            <div className="p-4 md:p-6 font-bold text-red-600 text-lg md:text-xl bg-red-50 text-center border-x border-red-100" data-id="element-125">
              Dentafix™
            </div>
            <div className="p-4 md:p-6 font-bold text-gray-500 text-sm md:text-lg text-center" data-id="element-126">
              Traditional Glue
            </div>
          </div>

          {rows.map((row, index) => <div key={index} className="grid grid-cols-3 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors" data-id="element-127">
              <div className="p-4 md:p-6 font-medium text-gray-700 flex items-center" data-id="element-128">
                {row.feature}
              </div>
              <div className="p-4 md:p-6 bg-red-50/30 border-x border-red-100 flex items-center justify-center gap-2 text-center" data-id="element-129">
                <div className="bg-green-100 p-1 rounded-full shrink-0" data-id="element-130">
                  <Check className="w-4 h-4 text-green-600" data-id="element-131" />
                </div>
                <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-132">
                  {row.dentafix}
                </span>
              </div>
              <div className="p-4 md:p-6 flex items-center justify-center gap-2 text-center" data-id="element-133">
                <div className="bg-red-100 p-1 rounded-full shrink-0" data-id="element-134">
                  <X className="w-4 h-4 text-red-600" data-id="element-135" />
                </div>
                <span className="text-gray-500 text-sm md:text-base" data-id="element-136">
                  {row.other}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}